import React, { Component, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Home from './Home';

const Portfolio = React.lazy(() => import('./Portfolio'))
const LivePreview = React.lazy(() => import('./LivePreview'))



class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      livePreviewURL: '',
    }
  }
  setURL = (livePreviewURL) => {
    this.setState({ livePreviewURL })
  }





  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/portfolio" exact>
            <Suspense fallback={<div>Loading...</div>}>
              <Portfolio onPreviewURLChange={this.setURL} />
            </Suspense>
          </Route>
          <Route path="/preview" exact>
            <Suspense fallback={<div>Loading...</div>}>
              <LivePreview previewURL={this.state.livePreviewURL} />
            </Suspense>
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default App;
